import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_CARD_TYPE_DEF,
} from "./actionTypes"

import {
    getCardTypeDefListSuccess,
    cardTypeDefApiError
} from "./actions"

import {
    GetAllCardTypeDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetCardTypeDefList() {
  try {
    const response = yield call(GetAllCardTypeDef)
    yield put(getCardTypeDefListSuccess(response))
  } catch (error) {
    yield put(cardTypeDefApiError(error))
  }
}

function* cardTypeDefSaga() {
    yield takeEvery(GET_CARD_TYPE_DEF,onGetCardTypeDefList)
}

export default cardTypeDefSaga